"use client";

import { useMarketingAnalytics } from "@analytics";
import { useTrackMountOnceEvent } from "@analytics/lib/mount-once-tracker";

export function MarketingNotFoundAnalytics() {
	const { notFoundViewed } = useMarketingAnalytics();

	useTrackMountOnceEvent("sq:analytics:not-found-viewed:marketing", () => {
		notFoundViewed({ surface: "marketing" });
	});

	return null;
}
